import { createAction, props } from '@ngrx/store';

export const loadRemoveBusinessManagementUsers = createAction(
  '[RemoveBusinessManagementUser] Load RemoveBusinessManagementUsers',
  props<{
    request: { businessId: string; businessUserProfileRoleId: string };
  }>()
);

export const loadRemoveBusinessManagementUsersSuccess = createAction(
  '[RemoveBusinessManagementUser] Load RemoveBusinessManagementUsers Success',
  props<{ response: boolean }>()
);

export const loadRemoveBusinessManagementUsersFailure = createAction(
  '[RemoveBusinessManagementUser] Load RemoveBusinessManagementUsers Failure',
  props<{ error: Error | any }>()
);
